module.exports = __webpack_public_path__ + "static/media/slider-l1.f4bdd1b2.webp";